/**
 * Normalize list-like Redux action payloads (array | Map | plain object values).
 */

export function normalizeReduxListPayload(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (payload instanceof Map) return Array.from(payload.values());
  if (typeof payload === "object") return Object.values(payload);
  return [];
}
